import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import axios from 'axios';
import {
  Heart, Users, Package, Truck, Brain, FileText, Smartphone, Shield,
  ChevronRight, CheckCircle2, Mail, Phone, Send, ArrowRight, Menu, X,
  BarChart3, Upload, Megaphone, Globe
} from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const HERO_IMG = "https://static.prod-images.emergentagent.com/jobs/7cf6a038-7527-450d-8e3d-0906d9d74af3/images/e7fd54ace14bc99e11bfa90b361c456a8f4553fa6cca3792a3114bbaeeb067d8.png";
const AI_IMG = "https://static.prod-images.emergentagent.com/jobs/7cf6a038-7527-450d-8e3d-0906d9d74af3/images/46e42ba16d1d04ca65641ab255652fa091c458fca0234774123adb4ddeac5c84.png";
const FAMILIES_IMG = "https://static.prod-images.emergentagent.com/jobs/7cf6a038-7527-450d-8e3d-0906d9d74af3/images/74896f8b089b73c45bb9a55d596d1ce5d228a67377ed6167bed6ce516614e4ec.png";
const MOBILE_IMG = "https://static.prod-images.emergentagent.com/jobs/7cf6a038-7527-450d-8e3d-0906d9d74af3/images/5aeaeda060e0ec209d5bc7777f620f63f4a43f41fe68d250629543b473bb032a.png";

const features = [
  { icon: Users, title: "Gestione Famiglie", desc: "Anagrafica completa con composizione nucleo, ISEE, priorita e documenti. Tutto organizzato e sempre aggiornato." },
  { icon: Package, title: "Magazzino Intelligente", desc: "Tracciamento scorte in tempo reale, avvisi sotto scorta e scadenze. Mai piu sprechi o prodotti dimenticati." },
  { icon: Brain, title: "AI per le Distribuzioni", desc: "L'intelligenza artificiale suggerisce la composizione del pacco in base alla famiglia, al magazzino e all'equita." },
  { icon: Smartphone, title: "Firma Digitale", desc: "Il beneficiario firma la ricevuta direttamente su tablet o smartphone. Niente piu fogli di carta." },
  { icon: FileText, title: "Documenti PDF Automatici", desc: "Genera richieste per il banco alimentare e ricevute firmate con un click. Pronte da stampare o inviare." },
  { icon: Upload, title: "Import da Excel", desc: "Carica centinaia di famiglie o prodotti da un file Excel. L'AI mappa automaticamente le colonne." },
  { icon: Megaphone, title: "Comunicazioni", desc: "Pubblica avvisi ed eventi visibili a tutti gli utenti e alle famiglie. Tutti sempre informati." },
  { icon: Globe, title: "Portale Famiglia", desc: "Le famiglie accedono al proprio portale per consultare lo storico degli aiuti e i propri documenti." },
];

const stats = [
  { value: "100%", label: "Digitale" },
  { value: "AI", label: "Integrata" },
  { value: "Multi", label: "Chiesa" },
  { value: "0", label: "Carta" },
];

const LandingPage = () => {
  const navigate = useNavigate();
  const [mobileMenu, setMobileMenu] = useState(false);
  const [form, setForm] = useState({ nome: '', email: '', telefono: '', organizzazione: '', messaggio: '' });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.nome || !form.email || !form.messaggio) {
      toast.error('Compila nome, email e messaggio'); return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/contatti`, form);
      setSent(true);
      toast.success('Messaggio inviato! Ti ricontatteremo presto.');
      setForm({ nome: '', email: '', telefono: '', organizzazione: '', messaggio: '' });
    } catch {
      toast.error('Errore nell\'invio. Riprova.');
    } finally { setSending(false); }
  };

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMobileMenu(false);
  };

  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      {/* Navbar */}
      <nav className="fixed top-0 w-full z-50 bg-white/90 backdrop-blur-md border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-2">
              <Heart className="w-7 h-7 text-[#C0604D]" fill="#C0604D" />
              <span className="text-xl font-bold text-gray-900">AGAPE <span className="text-[#C0604D]">HUB</span></span>
            </div>
            <div className="hidden md:flex items-center gap-8">
              <button onClick={() => scrollTo('funzionalita')} className="text-sm text-gray-600 hover:text-[#C0604D] transition-colors">Funzionalita</button>
              <button onClick={() => scrollTo('come-funziona')} className="text-sm text-gray-600 hover:text-[#C0604D] transition-colors">Come Funziona</button>
              <button onClick={() => scrollTo('prezzi')} className="text-sm text-gray-600 hover:text-[#C0604D] transition-colors">Prezzi</button>
              <button onClick={() => scrollTo('contattaci')} className="text-sm text-gray-600 hover:text-[#C0604D] transition-colors">Contattaci</button>
              <Button onClick={() => navigate('/login')} size="sm" className="bg-[#C0604D] hover:bg-[#a84d3d]" data-testid="landing-login-btn">
                Accedi <ArrowRight className="w-4 h-4 ml-1" />
              </Button>
            </div>
            <button className="md:hidden" onClick={() => setMobileMenu(!mobileMenu)}>
              {mobileMenu ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
        {mobileMenu && (
          <div className="md:hidden bg-white border-t px-4 py-4 space-y-3">
            <button onClick={() => scrollTo('funzionalita')} className="block w-full text-left text-sm text-gray-700 py-2">Funzionalita</button>
            <button onClick={() => scrollTo('come-funziona')} className="block w-full text-left text-sm text-gray-700 py-2">Come Funziona</button>
            <button onClick={() => scrollTo('prezzi')} className="block w-full text-left text-sm text-gray-700 py-2">Prezzi</button>
            <button onClick={() => scrollTo('contattaci')} className="block w-full text-left text-sm text-gray-700 py-2">Contattaci</button>
            <Button onClick={() => navigate('/login')} className="w-full bg-[#C0604D] hover:bg-[#a84d3d]">Accedi</Button>
          </div>
        )}
      </nav>

      {/* Hero */}
      <section className="pt-24 pb-16 sm:pt-32 sm:pb-24 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="space-y-6 sm:space-y-8">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#C0604D]/10 text-[#C0604D] text-xs font-medium">
                <Heart className="w-3.5 h-3.5" fill="#C0604D" /> Piattaforma per il Sociale
              </div>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                Gestisci il tuo
                <span className="text-[#C0604D]"> Banco Alimentare</span>
                <br />con semplicita
              </h1>
              <p className="text-base sm:text-lg text-gray-600 max-w-xl leading-relaxed">
                AGAPE HUB e la piattaforma web che aiuta chiese e organizzazioni caritative a 
                gestire famiglie, magazzino, donazioni e distribuzioni in modo organizzato, 
                trasparente e intelligente.
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <Button size="lg" className="bg-[#C0604D] hover:bg-[#a84d3d] text-base px-8"
                  onClick={() => scrollTo('contattaci')} data-testid="hero-cta-btn">
                  Richiedi una Demo <ChevronRight className="w-5 h-5 ml-1" />
                </Button>
                <Button size="lg" variant="outline" className="text-base border-gray-300"
                  onClick={() => scrollTo('funzionalita')}>
                  Scopri le Funzionalita
                </Button>
              </div>
              {/* Stats */}
              <div className="grid grid-cols-4 gap-4 pt-4">
                {stats.map((s, i) => (
                  <div key={i} className="text-center">
                    <p className="text-2xl sm:text-3xl font-bold text-[#C0604D]">{s.value}</p>
                    <p className="text-xs text-gray-500 mt-0.5">{s.label}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-[#C0604D]/10">
                <img src={HERO_IMG} alt="AGAPE HUB" className="w-full h-auto" />
              </div>
              <div className="absolute -bottom-4 -left-4 w-24 h-24 bg-[#C0604D]/10 rounded-full blur-2xl" />
              <div className="absolute -top-4 -right-4 w-32 h-32 bg-amber-200/30 rounded-full blur-2xl" />
            </div>
          </div>
        </div>
      </section>

      {/* Features Grid */}
      <section id="funzionalita" className="py-16 sm:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <p className="text-sm font-medium text-[#C0604D] mb-2">FUNZIONALITA</p>
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">Tutto cio di cui hai bisogno</h2>
            <p className="text-base text-gray-600 mt-3 max-w-2xl mx-auto">Una piattaforma completa per gestire ogni aspetto del tuo banco alimentare, dall'anagrafica alla distribuzione.</p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
            {features.map((f, i) => (
              <div key={i} className="bg-white rounded-xl p-5 sm:p-6 border border-gray-100 hover:shadow-lg hover:border-[#C0604D]/20 transition-all duration-300 group">
                <div className="w-11 h-11 rounded-lg bg-[#C0604D]/10 flex items-center justify-center mb-4 group-hover:bg-[#C0604D] transition-colors">
                  <f.icon className="w-5 h-5 text-[#C0604D] group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-sm font-semibold text-gray-900 mb-2">{f.title}</h3>
                <p className="text-xs text-gray-600 leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How it works - Visual sections */}
      <section id="come-funziona" className="py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <p className="text-sm font-medium text-[#C0604D] mb-2">COME FUNZIONA</p>
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">Semplice, veloce, intelligente</h2>
          </div>

          {/* Row 1 - AI */}
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center mb-16 sm:mb-24">
            <div className="order-2 lg:order-1">
              <div className="rounded-2xl overflow-hidden shadow-xl">
                <img src={AI_IMG} alt="AI Distribuzione" className="w-full h-auto" />
              </div>
            </div>
            <div className="order-1 lg:order-2 space-y-4">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-50 text-blue-600 text-xs font-medium">
                <Brain className="w-3.5 h-3.5" /> Intelligenza Artificiale
              </div>
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-900">L'AI prepara il pacco per te</h3>
              <p className="text-gray-600 leading-relaxed">
                Quando crei una distribuzione, il sistema analizza la composizione della famiglia, 
                controlla il magazzino e suggerisce automaticamente cosa mettere nel pacco. 
                Da priorita ai prodotti in scadenza e garantisce equita tra tutte le famiglie.
              </p>
              <div className="space-y-2.5 pt-2">
                {["Analisi nucleo familiare", "Priorita scadenze", "Equita nella distribuzione", "Sempre modificabile"].map((t, i) => (
                  <div key={i} className="flex items-center gap-2.5">
                    <CheckCircle2 className="w-4.5 h-4.5 text-green-500 flex-shrink-0" />
                    <span className="text-sm text-gray-700">{t}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Row 2 - Families */}
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center mb-16 sm:mb-24">
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-50 text-amber-600 text-xs font-medium">
                <Users className="w-3.5 h-3.5" /> Gestione Completa
              </div>
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-900">Famiglie al centro</h3>
              <p className="text-gray-600 leading-relaxed">
                Registra ogni famiglia con tutti i dettagli: composizione nucleo, situazione economica, 
                documenti e storico aiuti. L'AI analizza i documenti caricati per estrarre automaticamente 
                i dati. Ogni famiglia puo avere un portale personale per consultare il proprio storico.
              </p>
              <div className="space-y-2.5 pt-2">
                {["Anagrafica dettagliata", "Analisi documenti AI", "Portale famiglia dedicato", "Storico completo"].map((t, i) => (
                  <div key={i} className="flex items-center gap-2.5">
                    <CheckCircle2 className="w-4.5 h-4.5 text-green-500 flex-shrink-0" />
                    <span className="text-sm text-gray-700">{t}</span>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <div className="rounded-2xl overflow-hidden shadow-xl">
                <img src={FAMILIES_IMG} alt="Gestione Famiglie" className="w-full h-auto" />
              </div>
            </div>
          </div>

          {/* Row 3 - Mobile */}
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="order-2 lg:order-1">
              <div className="rounded-2xl overflow-hidden shadow-xl">
                <img src={MOBILE_IMG} alt="Mobile e Firma" className="w-full h-auto" />
              </div>
            </div>
            <div className="order-1 lg:order-2 space-y-4">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-green-50 text-green-600 text-xs font-medium">
                <Smartphone className="w-3.5 h-3.5" /> Mobile-First
              </div>
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-900">Firma digitale e PDF</h3>
              <p className="text-gray-600 leading-relaxed">
                Il beneficiario firma la ricevuta direttamente sullo schermo del tuo tablet o smartphone. 
                Niente piu fogli di carta, tutto digitale e tracciabile. Scarica la ricevuta in PDF 
                con un click, completa di firma e intestazione della tua organizzazione.
              </p>
              <div className="space-y-2.5 pt-2">
                {["Firma su qualsiasi dispositivo", "Ricevuta PDF automatica", "Completamente responsive", "Zero carta"].map((t, i) => (
                  <div key={i} className="flex items-center gap-2.5">
                    <CheckCircle2 className="w-4.5 h-4.5 text-green-500 flex-shrink-0" />
                    <span className="text-sm text-gray-700">{t}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section id="vantaggi" className="py-16 sm:py-24 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <p className="text-sm font-medium text-[#C0604D] mb-2">PERCHE SCEGLIERCI</p>
            <h2 className="text-3xl sm:text-4xl font-bold">I vantaggi di AGAPE HUB</h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { icon: Shield, title: "Multi-tenant sicuro", desc: "Ogni chiesa ha i propri dati completamente isolati. Massima privacy e sicurezza." },
              { icon: Brain, title: "Intelligenza Artificiale", desc: "L'AI ti assiste in tutto: dalla composizione pacchi, all'analisi documenti, all'import dati." },
              { icon: Smartphone, title: "Funziona ovunque", desc: "Desktop, tablet, smartphone. Accedi da qualsiasi dispositivo con un browser web." },
              { icon: BarChart3, title: "Dashboard in tempo reale", desc: "Statistiche sempre aggiornate: famiglie, scorte, donazioni, distribuzioni. Tutto a colpo d'occhio." },
              { icon: FileText, title: "Zero burocrazia", desc: "PDF automatici, firma digitale, import da Excel. Basta fogli di carta e file sparsi." },
              { icon: Heart, title: "Fatto per il Sociale", desc: "Progettato con sensibilita: nessun prezzo visibile alle famiglie, portale personale rispettoso." },
            ].map((b, i) => (
              <div key={i} className="bg-white/5 backdrop-blur rounded-xl p-6 border border-white/10 hover:border-[#C0604D]/40 transition-all">
                <b.icon className="w-8 h-8 text-[#C0604D] mb-4" />
                <h3 className="text-base font-semibold mb-2">{b.title}</h3>
                <p className="text-sm text-gray-400 leading-relaxed">{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section id="prezzi" className="py-16 sm:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-4">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-green-100 text-green-700 text-sm font-medium mb-6">
              <CheckCircle2 className="w-4 h-4" /> Attualmente GRATIS — Siamo in fase di test!
            </div>
            <p className="text-sm font-medium text-[#C0604D] mb-2">PREZZI</p>
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">Scegli il piano adatto a te</h2>
            <p className="text-base text-gray-600 mt-3 max-w-2xl mx-auto">Inizia gratuitamente. Quando sarai pronto, scegli il piano che fa per la tua organizzazione.</p>
          </div>

          <div className="grid sm:grid-cols-3 gap-6 max-w-5xl mx-auto mt-10">
            {/* Free */}
            <div className="bg-white rounded-2xl border border-gray-200 p-6 sm:p-8 flex flex-col">
              <div className="mb-6">
                <p className="text-sm font-medium text-gray-500 mb-1">Free</p>
                <div className="flex items-baseline gap-1">
                  <span className="text-4xl font-bold text-gray-900">0</span>
                  <span className="text-lg text-gray-400">/mese</span>
                </div>
                <p className="text-xs text-gray-500 mt-2">Perfetto per iniziare e provare la piattaforma</p>
              </div>
              <div className="space-y-3 flex-1">
                {[
                  { ok: true, t: "1 Admin" },
                  { ok: true, t: "Gestione Famiglie" },
                  { ok: true, t: "Magazzino e Donazioni" },
                  { ok: true, t: "Distribuzioni con AI" },
                  { ok: true, t: "Comunicazioni" },
                  { ok: false, t: "Volontari" },
                  { ok: false, t: "Portale Famiglia" },
                  { ok: false, t: "Import Massivo" },
                  { ok: true, t: "Pubblicita discreta" },
                ].map((f, i) => (
                  <div key={i} className="flex items-center gap-2.5">
                    {f.ok ? <CheckCircle2 className="w-4 h-4 text-green-500 flex-shrink-0" /> : <X className="w-4 h-4 text-gray-300 flex-shrink-0" />}
                    <span className={`text-sm ${f.ok ? 'text-gray-700' : 'text-gray-400'}`}>{f.t}</span>
                  </div>
                ))}
              </div>
              <Button variant="outline" className="w-full mt-6" onClick={() => scrollTo('contattaci')}>
                Inizia Gratis
              </Button>
            </div>

            {/* Basic */}
            <div className="bg-white rounded-2xl border-2 border-[#C0604D] p-6 sm:p-8 flex flex-col relative shadow-lg">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-[#C0604D] text-white text-xs font-medium rounded-full">
                Consigliato
              </div>
              <div className="mb-6">
                <p className="text-sm font-medium text-[#C0604D] mb-1">Basic</p>
                <div className="flex items-baseline gap-1">
                  <span className="text-4xl font-bold text-gray-900">29,90</span>
                  <span className="text-lg text-gray-400">/mese</span>
                </div>
                <p className="text-xs text-gray-500 mt-2">Per chiese con un team di volontari</p>
              </div>
              <div className="space-y-3 flex-1">
                {[
                  { ok: true, t: "Admin illimitati" },
                  { ok: true, t: "Gestione Famiglie" },
                  { ok: true, t: "Magazzino e Donazioni" },
                  { ok: true, t: "Distribuzioni con AI" },
                  { ok: true, t: "Comunicazioni" },
                  { ok: true, t: "Volontari illimitati" },
                  { ok: true, t: "Import Massivo" },
                  { ok: false, t: "Portale Famiglia" },
                  { ok: true, t: "Nessuna pubblicita" },
                ].map((f, i) => (
                  <div key={i} className="flex items-center gap-2.5">
                    {f.ok ? <CheckCircle2 className="w-4 h-4 text-green-500 flex-shrink-0" /> : <X className="w-4 h-4 text-gray-300 flex-shrink-0" />}
                    <span className={`text-sm ${f.ok ? 'text-gray-700' : 'text-gray-400'}`}>{f.t}</span>
                  </div>
                ))}
              </div>
              <Button className="w-full mt-6 bg-[#C0604D] hover:bg-[#a84d3d]" onClick={() => scrollTo('contattaci')}>
                Scegli Basic
              </Button>
            </div>

            {/* Pro */}
            <div className="bg-white rounded-2xl border border-gray-200 p-6 sm:p-8 flex flex-col">
              <div className="mb-6">
                <p className="text-sm font-medium text-gray-500 mb-1">Pro</p>
                <div className="flex items-baseline gap-1">
                  <span className="text-4xl font-bold text-gray-900">34,90</span>
                  <span className="text-lg text-gray-400">/mese</span>
                </div>
                <p className="text-xs text-gray-500 mt-2">Tutto incluso, anche il portale famiglia</p>
              </div>
              <div className="space-y-3 flex-1">
                {[
                  { ok: true, t: "Admin illimitati" },
                  { ok: true, t: "Gestione Famiglie" },
                  { ok: true, t: "Magazzino e Donazioni" },
                  { ok: true, t: "Distribuzioni con AI" },
                  { ok: true, t: "Comunicazioni" },
                  { ok: true, t: "Volontari illimitati" },
                  { ok: true, t: "Import Massivo" },
                  { ok: true, t: "Portale Famiglia" },
                  { ok: true, t: "Nessuna pubblicita" },
                ].map((f, i) => (
                  <div key={i} className="flex items-center gap-2.5">
                    <CheckCircle2 className="w-4 h-4 text-green-500 flex-shrink-0" />
                    <span className="text-sm text-gray-700">{f.t}</span>
                  </div>
                ))}
              </div>
              <Button variant="outline" className="w-full mt-6 border-[#C0604D] text-[#C0604D] hover:bg-[#C0604D] hover:text-white" onClick={() => scrollTo('contattaci')}>
                Scegli Pro
              </Button>
            </div>
          </div>

          <p className="text-center text-xs text-gray-400 mt-8">I prezzi indicati entreranno in vigore al termine della fase di test gratuita. Sarai avvisato con anticipo.</p>
        </div>
      </section>

      {/* Contact Form */}
      <section id="contattaci" className="py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16">
            <div className="space-y-6">
              <p className="text-sm font-medium text-[#C0604D]">CONTATTACI</p>
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
                Vuoi utilizzare AGAPE HUB per la tua organizzazione?
              </h2>
              <p className="text-gray-600 leading-relaxed">
                Compila il modulo e ti ricontatteremo per una dimostrazione gratuita. 
                Ti mostreremo come AGAPE HUB puo aiutare la tua chiesa o organizzazione 
                a gestire il banco alimentare in modo efficiente.
              </p>
              <div className="space-y-4 pt-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-[#C0604D]/10 flex items-center justify-center">
                    <Mail className="w-5 h-5 text-[#C0604D]" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-900">Email</p>
                    <p className="text-sm text-gray-600">adschiliro@gmail.com</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-[#C0604D]/10 flex items-center justify-center">
                    <CheckCircle2 className="w-5 h-5 text-[#C0604D]" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-900">Demo gratuita</p>
                    <p className="text-sm text-gray-600">Ti mostriamo la piattaforma senza impegno</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 border border-gray-100">
              {sent ? (
                <div className="text-center py-12 space-y-4">
                  <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto">
                    <CheckCircle2 className="w-8 h-8 text-green-600" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">Messaggio inviato!</h3>
                  <p className="text-gray-600">Ti ricontatteremo il prima possibile.</p>
                  <Button variant="outline" onClick={() => setSent(false)}>Invia un altro messaggio</Button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-4">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Richiedi informazioni</h3>
                  <div className="grid grid-cols-2 gap-3">
                    <div className="space-y-1.5">
                      <Label className="text-xs">Nome e Cognome *</Label>
                      <Input value={form.nome} onChange={e => setForm({...form, nome: e.target.value})}
                        placeholder="Mario Rossi" required className="bg-white" data-testid="contact-nome" />
                    </div>
                    <div className="space-y-1.5">
                      <Label className="text-xs">Email *</Label>
                      <Input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})}
                        placeholder="mario@email.it" required className="bg-white" data-testid="contact-email" />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div className="space-y-1.5">
                      <Label className="text-xs">Telefono</Label>
                      <Input value={form.telefono} onChange={e => setForm({...form, telefono: e.target.value})}
                        placeholder="333 1234567" className="bg-white" data-testid="contact-telefono" />
                    </div>
                    <div className="space-y-1.5">
                      <Label className="text-xs">Organizzazione</Label>
                      <Input value={form.organizzazione} onChange={e => setForm({...form, organizzazione: e.target.value})}
                        placeholder="Chiesa / Associazione" className="bg-white" data-testid="contact-organizzazione" />
                    </div>
                  </div>
                  <div className="space-y-1.5">
                    <Label className="text-xs">Messaggio *</Label>
                    <Textarea value={form.messaggio} onChange={e => setForm({...form, messaggio: e.target.value})}
                      placeholder="Raccontaci della tua organizzazione e come vorresti usare AGAPE HUB..."
                      rows={4} required className="bg-white resize-none" data-testid="contact-messaggio" />
                  </div>
                  <Button type="submit" className="w-full bg-[#C0604D] hover:bg-[#a84d3d] text-base h-11"
                    disabled={sending} data-testid="contact-submit-btn">
                    {sending ? 'Invio in corso...' : <><Send className="w-4 h-4 mr-2" /> Invia Messaggio</>}
                  </Button>
                  <p className="text-[10px] text-gray-400 text-center">I tuoi dati verranno trattati con riservatezza.</p>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-10 sm:py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <Heart className="w-5 h-5 text-[#C0604D]" fill="#C0604D" />
              <span className="text-lg font-bold">AGAPE <span className="text-[#C0604D]">HUB</span></span>
            </div>
            <p className="text-sm text-gray-400">Piattaforma di Gestione Banco Alimentare</p>
            <div className="flex items-center gap-4 text-sm text-gray-400">
              <a href="mailto:adschiliro@gmail.com" className="hover:text-white transition-colors flex items-center gap-1">
                <Mail className="w-4 h-4" /> adschiliro@gmail.com
              </a>
            </div>
          </div>
          <div className="mt-6 pt-6 border-t border-white/10 text-center">
            <p className="text-xs text-gray-500">&copy; 2026 AGAPE HUB. Tutti i diritti riservati.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
